import ActiveRecord from './active_record/base'

class ShiftType extends ActiveRecord {
	static tableName = 'shiftTypes'
}

export default ShiftType
